import React, { ReactElement } from 'react';
import { styled } from '@linaria/react';
import { Text } from '../Text';
interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** Name of radio button. Programmatically set by parent component SegmentedControl */
  name?: string;
  /** Value of current radio button */
  value: string;
  /** Checked state of current radio button. Programmatically set by parent component */
  checked?: boolean;
  /** An onChange callback passed down by the controlling parent component */
  onChange?: (event: React.ChangeEvent) => void;
  /** An icon placed before the item content. It can be any type of React Element */
  icon?: ReactElement;
  /** Text content of current item */
  children: string | ReactElement;
  /** Whether the SegmentedControl should span the whole available width. Programmatically set by parent component  */
  isFullWidth?: boolean;
}
export const ItemBody = /*#__PURE__*/styled('div')({
  name: "ItemBody",
  class: "ix0v5a8",
  propsAsIs: false
});
const _exp14 = /*#__PURE__*/() => ({
  isFullWidth
}) => isFullWidth ? 'inline-grid' : 'inline-flex';
const _exp15 = /*#__PURE__*/() => ({
  isFullWidth
}) => isFullWidth ? '1' : '0';
const Wrapper = /*#__PURE__*/styled('label')({
  name: "Wrapper",
  class: "w1itfy02",
  propsAsIs: false,
  vars: {
    "w1itfy02-0": [_exp14()],
    "w1itfy02-1": [_exp15()]
  }
});
export const Input = /*#__PURE__*/styled('input')({
  name: "Input",
  class: "i1hp12dr",
  propsAsIs: false
});
export const SegmentedControlItem = ({
  icon,
  name,
  value,
  checked,
  onChange,
  isFullWidth = false,
  children,
  className
}: Props) => {
  return <Wrapper className={className} isFullWidth={isFullWidth}>
      <Input type="radio" name={name} value={value} checked={checked} onChange={onChange} />
      <ItemBody>
        {icon && icon}
        <Text variant="labelS" tag="span">
          {children}
        </Text>
      </ItemBody>
    </Wrapper>;
};

require("./SegmentedControlItem.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SegmentedControlItem.tsx");